import envelope from './envelope';
import subscription from './subscription';
import onboardings from './onboardings';
import envelopeSettings from './envelopeSettings';
import envelopeConfig from './envelopeConfig';

export default {
  envelope,
  subscription,
  onboardings,
  envelopeSettings,
  envelopeConfig,
};
